// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"d199863e","117":"74839992","260":"2552506f","371":"e1ec7ae6","488":"641d53cc","578":"02674e98","596":"d90d31f8","599":"ed416618","631":"4e1cc2fe","725":"55f7743b"}[chunkId] + ".chunk.js";
};